import React, { useEffect, useState } from "react";

import DashboardGreeting from "../DashboardGreeting";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AddIcon from "../../assets/images/addIcon.svg";
import AddHoliday from "./AddHoliday";

import DataTableComponent from "../Charts/DatatableComponent";
import EditHoliday from "./EditHoliday";
import HolidayService from "../../services/holiday.service";
import Delete from "../common/CustomModals/Delete";
import DataTable from "react-data-table-component";

import moment from "moment";
import { Empty, Skeleton } from "antd";

const HolidayList = ({ user }) => {
  const navHeading = "Holiday List";

  const [holiday, setHoliday] = useState(false);
  const [editHoliday, setEditHoliday] = useState(false);

  const [deleteHoliday, setDeleteHoliday] = useState(false);

  const [holidayList, setHolidayList] = useState([]);

  const [loading, setLoading] = useState(false);

  const [holidayData, setHolidayData] = useState("");

  const columns = [
    {
      name: "Sr. no",
      selector: (row) => row.srNo,
      cell: (row) => (
        <>
          <span title={`${row.srNo}`}>{`${row.srNo}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      cell: (row) => (
        <>
          <span title={`${row.date}`}>{`${moment(row.date, "DD-MM-YYYY").format(
            "Do MMM",
          )}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Day",
      selector: (row) => row.dayname,
      cell: (row) => (
        <>
          <span title={`${row.dayname}`}>{`${row.dayname}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Holiday Type",
      selector: (row) => row.htype,
      cell: (row) => (
        <>
          <span title={`${row.htype}`}>{`${row.htype}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Holiday Name",
      selector: (row) => row.hname,
      cell: (row) => (
        <>
          <span title={`${row.hname}`}>{`${row.hname}`}</span>
        </>
      ),
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row.id,
      cell: (row) => (
        <>
          <div className="d-flex gap-2">
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {
                  setEditHoliday(true);
                  fetchHolidayById(row.id);
                }}
              >
                <path
                  d="M16.7925 6.61653L6.90079 16.5082C6.01746 17.3999 3.37578 17.8081 2.77578 17.2165C2.17578 16.6248 2.60079 13.9832 3.48413 13.0916L13.3758 3.19989C13.8326 2.7649 14.4412 2.5257 15.0719 2.53338C15.7026 2.54107 16.3053 2.79504 16.7513 3.24104C17.1973 3.68703 17.4512 4.28973 17.459 4.92042C17.4666 5.55111 17.2275 6.1598 16.7925 6.61653Z"
                  stroke="#4E465E"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {
                  setDeleteHoliday(true);
                  fetchHolidayById(row.id);
                }}
              >
                <path
                  d="M4 7H20"
                  stroke="#4E465E"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                  stroke="#4E465E"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                  stroke="#4E465E"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
        </>
      ),
      sortable: true,
      omit: user.role !== "1",
    },
  ];

  const fetchHolidayList = () => {
    setLoading(true);
    HolidayService.getAllHolidayList()
      .then((resp) => {
        const filterdData = resp.data.map((item, index) => ({
          srNo: index + 1,
          ...item,
        }));
        setLoading(false);
        setHolidayList(filterdData);
      })
      .catch((e) => console.log(e));
  };

  const fetchHolidayById = (id) => {
    const data = {
      id: id,
    };

    HolidayService.getHolidayById(data)
      .then((resp) => {
        if (resp.data) {
          const dataWithId = {
            editId: id,
            ...resp.data,
          };
          setHolidayData(dataWithId);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchHolidayList();
  }, []);

  const removeHoliday = () => {
    const data = {
      id: holidayData.editId,
    };

    HolidayService.deleteHoliday(data)
      .then((resp) => {
        if (resp.data) {
          fetchHolidayList();
          toast.success("Holiday Deleted Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setDeleteHoliday(false),
          });
        }
      })
      .catch((e) => console.log(e));

    // console.log(data);
  };

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div className="filterBar mb-4">
          {user.role === "1" ? (
            <div className="action">
              <button
                className="apply feedback"
                onClick={(e) => {
                  setHoliday(true);
                }}
              >
                <span>
                  <img src={AddIcon} alt="" />
                </span>
                <span>Add holiday</span>
              </button>
            </div>
          ) : (
            <>&nbsp;</>
          )}
        </div>
        <ToastContainer />
        <div className="holidayList">
          {loading ? (
            <>
              <Skeleton active={loading} />
            </>
          ) : holidayList.length === 0 ? (
            <>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </>
          ) : (
            <>
              <DataTable columns={columns} data={holidayList} />
            </>
          )}
        </div>

        <div
          className={`${holiday ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setHoliday(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <AddHoliday
              holiday={holiday}
              setHoliday={setHoliday}
              fetchHolidayList={fetchHolidayList}
            />
          </div>
        </div>

        <div
          className={`${editHoliday ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setEditHoliday(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <EditHoliday
              holidayData={holidayData}
              editHoliday={editHoliday}
              setEditHoliday={setEditHoliday}
              fetchHolidayList={fetchHolidayList}
            />
          </div>
        </div>

        <div
          className={`${deleteHoliday ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setDeleteHoliday(false);
          }}
        >
          <div className="" onClick={(e) => e.stopPropagation()}>
            <Delete
              heading="Delete Holiday"
              para="Are you sure you want to delete this holiday?"
              showDelete={deleteHoliday}
              setShowDelete={setDeleteHoliday}
              remove={removeHoliday}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HolidayList;
